import React, { FC, Fragment } from 'react';
import { FieldArrayRenderProps } from 'formik';
import { findIndex, map, some } from 'lodash';
import { Box, Text, Checkbox } from '@bechtel/gds';
import { ListSelectionStyled } from '@bechtel/client-common';
import { CreateSingleBlockProps, FormikMilestoneIdGroup } from '../types';

type MilestoneListProps = FieldArrayRenderProps & CreateSingleBlockProps;

export const MilestoneList: FC<MilestoneListProps> = ({ form, push, remove, milestones }) => {
  return (
    <Fragment>
      {map(milestones, (milestoneGroup, milestoneName) => {
        const selected = findIndex(form.values.milestoneIds, (formikMilestoneGroup: FormikMilestoneIdGroup[]) => {
          return some(formikMilestoneGroup, (entity) => entity.id === milestoneGroup[0].id);
        });

        const onClick = () => {
          if (selected !== -1) {
            remove(selected);
          } else {
            push(milestoneGroup);
          }
        };

        return (
          <ListSelectionStyled data-testid={`milestone-${milestoneName}`} key={milestoneName} onClick={onClick}>
            <Box mr={{ sm: '500' }}>
              <Checkbox checked={selected !== -1} readOnly />
            </Box>
            <Text color="grey.1000" size="400">
              {milestoneName}
            </Text>
          </ListSelectionStyled>
        );
      })}
    </Fragment>
  );
};
